<template>
  <div v-if="documentSignature.relatedDocumentAgreement" class="mb-3">
    <div class="font-weight-bold">Візування</div>
    <span
      class="link"
      @click="
        $router.push({
          name: 'document-agreement-single',
          params: {
            id: documentSignature.relatedDocumentAgreement.id,
          },
        })
      ">
      {{ documentSignature.relatedDocumentAgreement.name }}
    </span>
  </div>
</template>

<script lang="ts">
import { useDocumentSignature } from '../index'

export default {
  name: 'ConnectedDocument',
  setup() {
    return { ...useDocumentSignature() }
  },
}
</script>

<style scoped lang="scss"></style>
